import "./polyfills";
import React from "react";
import ReactDOM from "react-dom/client";
import {BrowserRouter} from "react-router-dom";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* BrowserRouter gives every page a real, shareable path URL. The
        S3/CloudFront distribution rewrites unknown paths to index.html
        (CustomErrorResponses 403/404 -> /index.html, 200), so a refresh or
        a cold SMS deep-link on /dashboard, /account, etc. resolves. */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
